<template>
  <!-- Promotional Banner -->
  <div class="relative rounded-xl overflow-hidden flex h-32 sm:h-[256px] w-full sm:max-w-5xl mx-auto shadow-lg shadow-black/20">
    <!-- Background Image with Overlay -->
    <div class="absolute inset-0">
      <img
        :src="backgroundImage"
        :alt="backgroundImageAlt"
        class="w-full h-full object-cover object-top rounded-lg" />
      <!-- Gradient Overlays -->
      <div class="absolute inset-0 rounded-lg banner-gradient-primary"></div>
    </div>

    <!-- Content -->
    <div class="relative h-full flex flex-col justify-between px-2 sm:px-6 pt-2 pb-4 w-full">
      <!-- Top Section -->
      <div class="flex justify-between items-start">
        <!-- Pruta Logo -->

        <img :src="logoSrc" :alt="logoAlt" class="w-12 sm:w-20 p-1 sm:py-3" />


        <!-- Main Headline -->
        <h1 class="text-white text-right font-semibold text-lg sm:text-4xl leading-tight tracking-relax w-[13ch]">
          {{ headline }}
        </h1>
      </div>

      <!-- Bottom Section -->
      <div class="flex flex-col sm:flex-row items-end justify-between gap-4">
        <!-- Description Text -->
        
        <p class="hidden sm:block text-white text-sm sm:text-lg leading-relax flex-1">
          {{ description }}
        </p>

        <!-- CTA Button -->
        <Button
          variant="primary"
          size="sm"
          class="whitespace-nowrap text-sm md:text-base px-4 py-2 md:px-6 md:py-3"
          @click="$emit('cta-click')">
          <span class="md:hidden">Start Now</span>
          <span class="hidden md:inline">Create Your Free Account</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    backgroundImage?: string
    backgroundImageAlt?: string
    logoSrc?: string
    logoAlt?: string
    headline?: string
    description?: string
  }

  interface Emits {
    (e: 'cta-click'): void
  }

  withDefaults(defineProps<Props>(), {
    backgroundImage: '/images/banner-ads-01.webp',
    backgroundImageAlt: 'Real estate professionals',
    logoSrc: '/images/pruta-logo-white.svg',
    logoAlt: 'Pruta Logo',
    headline: 'Agents Compete, You Win',
    description:
      'On Pruta, agents pitch in an auction to earn your exclusive listing. Compare offers, commissions, and services — then choose the best deal for you.',

  })

  defineEmits<Emits>()
</script>

<style scoped>
  .banner-gradient-primary {
    background:
      linear-gradient(
        90deg,
        rgba(0, 81, 5, 0.19) 0%,
        rgba(0, 81, 5, 0.19) 100%
      ),
      linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.1) 100%
      ),
      linear-gradient(
        rgba(0, 0, 0, 0) 55.769%,
        rgba(0, 0, 0, 0.36) 76.923%,
        rgba(0, 0, 0, 0.9) 100%
      );
  }
</style>
